import { cn } from "@tarawa/ui";
import { useI18n } from "@/lib/i18n";

/** Brand mark: a fresh mint leaf. Wordmark switches between Latin and Arabic script. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cn("size-9", className)} aria-hidden="true">
      <rect width="64" height="64" rx="18" fill="var(--color-brand-600)" />
      <path d="M32 13c9 6 14 14 14 22a14 14 0 0 1-28 0c0-8 5-16 14-22z" fill="var(--color-brand-100)" />
      <path d="M32 22v26" stroke="var(--color-brand-600)" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M32 33l7-6M32 40l-7-6" stroke="var(--color-brand-600)" strokeWidth="3" strokeLinecap="round" />
      <circle cx="47" cy="17" r="4" fill="var(--color-saffron-400)" />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  const { t } = useI18n();
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <LogoMark />
      <span className="text-xl font-extrabold tracking-tight text-brand-800">{t("app.name")}</span>
    </span>
  );
}
